import { formatINR, todayIso } from '../../shared/data/common';

export const promoKinds = {
  General: { label: 'General', blurb: 'Any customer can use it within the dates and limits.' },
  FirstBooking: { label: 'First booking', blurb: 'Only customers with no earlier booking. Limited to one use per customer.' },
  Festival: { label: 'Festival', blurb: 'A seasonal offer for a named festival, valid only between its dates.' },
};

export const statusInfo = {
  Active: 'Active',
  Scheduled: 'Scheduled',
  Expired: 'Expired',
  UsedUp: 'Used up',
  Inactive: 'Off',
};

export const emptyPromoForm = () => ({
  code: '',
  title: '',
  description: '',
  kind: 'General',
  festivalName: '',
  products: [],
  discountType: 'Percentage',
  discountValue: '',
  maxDiscount: '',
  minBookingAmount: '',
  validFrom: todayIso(),
  validUntil: '',
  usageLimit: '',
  perCustomerLimit: '',
  isActive: true,
  showOnSite: true,
});

const text = (v) => (v == null ? '' : String(v));

export const toPromoForm = (promo) => ({
  ...emptyPromoForm(),
  ...promo,
  description: text(promo.description),
  festivalName: text(promo.festivalName),
  discountValue: text(promo.discountValue),
  maxDiscount: text(promo.maxDiscount),
  minBookingAmount: text(promo.minBookingAmount),
  usageLimit: text(promo.usageLimit),
  perCustomerLimit: text(promo.perCustomerLimit),
});

const num = (v) => (v === '' || v == null ? null : Number(v));

export const toPromoRequest = (form) => ({
  code: form.code.trim().toUpperCase(),
  title: form.title.trim(),
  description: form.description.trim() || null,
  kind: form.kind,
  festivalName: form.kind === 'Festival' ? form.festivalName.trim() : null,
  products: form.products,
  discountType: form.discountType,
  discountValue: Number(form.discountValue),
  maxDiscount: form.discountType === 'Percentage' ? num(form.maxDiscount) : null,
  minBookingAmount: num(form.minBookingAmount),
  validFrom: form.validFrom,
  validUntil: form.validUntil,
  usageLimit: num(form.usageLimit),
  perCustomerLimit: form.kind === 'FirstBooking' ? 1 : num(form.perCustomerLimit),
  isActive: form.isActive,
  showOnSite: form.showOnSite,
});

export const describeDiscount = (p) => (p.discountType === 'Percentage'
  ? `${Number(p.discountValue)}% off${p.maxDiscount ? `, up to ${formatINR(p.maxDiscount)}` : ''}`
  : `${formatINR(p.discountValue)} off`);
